<template>
	<div class="declaration-summary-statistics">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right">
										<Breadcrumb></Breadcrumb>
									</div>
									<h3 class="header-title mb-3">
										申报汇总统计
									</h3>
								</div> <!-- end page-title-box -->
							</div> <!-- end col-->
						</div>
		
						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<ul class="tab-list">
											<li class="tab-item" :class="{active:curTabIndex==index}" v-for="(item,index) in tabList" :key="index" @click="switchTab(index)">{{item}}</li>
										</ul>
										<DeclarationSum v-show="curTabIndex==0"></DeclarationSum>
										<DeclarationStat v-show="curTabIndex==1"></DeclarationStat>
										<DeclarationDetail v-show="curTabIndex==2"></DeclarationDetail>
										
									</div> <!-- end card-body-->
								</div> <!-- end card -->
							</div> <!-- end col-->
						</div>
				
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
	import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue'
	import DeclarationSum from './components/DeclarationSum.vue'
	import DeclarationStat from './components/DeclarationStat.vue'
	import DeclarationDetail from './components/DeclarationDetail.vue'
	export default {
		components:{
			Breadcrumb,
			DeclarationSum,
			DeclarationStat,
			DeclarationDetail,
		},
		data(){
			return {
				tabList:['申报汇总','申报统计','申报明细'],
				curTabIndex:0,
				list:[
					{
						name1:'重点课题',
						number1:10
					},
					{
						name2:'一般课题',
						number2:20
					}
				]
			}
		},
		methods:{
			// 切换tab
			switchTab(index){
				this.curTabIndex = index
			}
		}
	}
</script>

<style scoped lang="scss">
.tab-list{
	width: 100%;
		list-style: none;
		padding-left: 0;
		display: flex;
	.tab-item{
		width: 33.33%;
		// width: 50%;
		border-bottom: 2px solid #f2f3f5;
		text-align: center;
		font-weight: bold;
		line-height: 35px;
		cursor: pointer;
	}
	.tab-item.active{
		border-color: #9aa1f7;
	}
}
</style>